import script from "./Teen.vue?vue&type=script&setup=true&lang=ts"
export * from "./Teen.vue?vue&type=script&setup=true&lang=ts"

import "./Teen.vue?vue&type=style&index=0&id=8662dd62&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8662dd62"]])

export default __exports__